module.exports = __webpack_public_path__ + "static/media/Avenir-Black.857aa464.ttf";